<template>
    <v-app  id="app">
        
        <div class="mt-7 font-weight-black text-lg-h6">
            {{tutorName}} {{Status}}
        </div>
        <v-layout row>

            <v-flex lg12 xs12 class="mt-lg-10">

                

                <v-data-table :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" dense :headers="headers" hide-default-footer items-per-page="12"  :items="tables" item-key="name" class="elevation-0 table-rating">
                 
                             <template slot="item" slot-scope="props">

                                        <tr @click="monthForm(props.item)">
                                            <td class="text-center"> {{props.item.mo}} </td>
                                            <td class="text-center"> {{props.item.status}} </td>
                                            <td class="text-center"> {{props.item.ts}} </td>
                                            

                                        </tr>

                                    </template>


                </v-data-table> 
               

            </v-flex>

        </v-layout>

    </v-app>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
    name:'weeklyreport',
    props:['wkReport',"moNum","moReport"],
    data: () => ({
        months: [{'no':'01','month':'January'}, {'no':'02','month':'February'}, {'no':'03','month':'March'}, {'no':'04','month':'April'}, {'no':'05','month':'May'}, {'no':'06','month':'June'}, {'no':'07','month':'July'}, {'no':'08','month':'August'}, {'no':'09','month':'September'}, {'no':'10','month':'October'}, {'no':'11','month':'November'}, {'no':'12','month':'December'},],
        tables:[],
        teams:'',
            teamCat: [
                {category:'AM',
                value:"am"},
                 {category:'PM'
                 ,value:"pm"}],
        weekno:'',
        monthno:'',
        yearno:'',
        Status:'',
        averageScore:0,
        counter:0,
        tutorName:"",
        
    }),
    computed: {
       headers(){ return  [{

          
          text: 'Month',
          align: 'center',
          sortable: false,
          value: 'mo',
          class: "grey lighten-2"
        },
        { text: 'Status',align: 'center', value: 'status' , class: "grey lighten-2", sortable: false,},
        { text: 'Timestamp',align: 'center', value: 'ts',class: "grey lighten-2", sortable: false,},
        
        ]}
    },
    watch(){
    },
     mounted() {

      
         
       axios.get('https://phone.megatalking.com/origin/api/monitoring.php?action=getTutors')
        //.then(response=>console.warn(response.data))
        .then(response=>{
        
          let tutorlist = response.data
        
              for(let i = 0 ; i<=tutorlist.length ; i++){
                    


                    if(this.$route.params.t_id.toString().toLowerCase().indexOf(tutorlist[i].tutor_id.toLowerCase()) !== -1){
                        this.tutorName = tutorlist[i].tutor_full_name
                    }

               }
               
        })
         this.moReport.$on('updateMonths', this.updateMonths)
       this.getNoOfMonth()  
       

    },  
   methods:{
       

        getNoOfMonth(){
            
          
            
            for(let x =0 ; x<=12 ; x++){


                let monthNum = this.months[x].no
                let monthName = this.months[x].month
              this.getResultMonthly(monthNum,monthName)
                
            }

           
        },

         getResultMonthly(monthNum,monthName){

            axios.get('http://localhost/megatalking/performance/tutorperf.php?actionTaken=getMonthData&month='+monthNum+'&t_id='+this.$route.params.t_id+'')
                //.then(response=>console.warn(response.data))
                .then(response=>{
                    
                    let AllData = response.data
                    
                    if(AllData!="No data"){

                            this.tables.push({
                                
                                mo:monthName,
                                status:'Done',
                                ts:AllData.timestamp,
                                improve:AllData.improve,
                                strength:AllData.strength,
                                remarks:AllData.remarks,
                                moNum:monthNum

                            })

                    }else{

                         this.tables.push({
                                
                                mo:monthName,
                                status:'Pending',
                                ts:'yyyy-mm-dd hh:mm:ss',
                                improve:'',
                                strength:'',
                                remarks:'',
                                moNum:monthNum

                            })

                    }

                  
                   

            }).catch(error=>console.log('this is the error '+error))

        },
        
        monthForm(id){
        this.month = id.moNum
        this.$emit('monthForm',id)

       },

       updateMonths(){
         
         let data = Vue.prototype.$submitData
         let objIndex = this.tables.findIndex((obj => obj.moNum == this.month)); 

         this.tables[objIndex].status = 'Done'     
         this.tables[objIndex].ts = data.timestamp
         this.tables[objIndex].improve = data.improve
         this.tables[objIndex].strength = data.strength 
         this.tables[objIndex].remarks = data.remarks 


       },

   },
}
</script>
<style>
.averageScoreLabel{
    color:rgb(86, 86, 86);
    font-size:9px;
    margin-left: 120px !important;
}
.averageScore{
    color:rgb(0, 143, 58)
}
</style>